import React, { Component } from 'react'
import './LoginRegister.css'
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import loaderImg from '../../assets/images/loader-example.gif';
import Loader from 'react-loader-advanced';
import { login_list, doLoginRes} from '../../action/LoginAction';
import { createRegister, doRegisterRes} from '../../action/RegisterAction';
import {cartListView, doCartListRes} from '../../action/CartListAction';

import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';


var pattern = /^[+a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/i;

class LoginRegister extends Component {
    constructor(props){
        super(props);
        this.state={
            email: '',
            password: '',
            nameRegister: '',
            emailRegister: '',
            passwordRegister: '',
            userName: localStorage.getItem('userName')?localStorage.getItem('userName'):'',
            cartCheck: false,
            loginRemove: false,
            loginModalPopup: props.loginModalPopup,
            isLoader: false,
        }
        ReactGA.initialize('UA-64201999-5');
        ReactGA.pageview(window.location.pathname + window.location.search);

        ReactPixel.init('784849368913134');

        ReactPixel.pageView();
    }

    validate(values) {
        const errors = {};  
        if(values.nameRegister && values.nameRegister.trim() === ''){
            errors.nameRegister = '*Please enter user name';
        }else if(values.nameRegister === null){
        errors.nameRegister = '*Please enter user name';
        }else if(values.nameRegister === undefined){
        errors.nameRegister = '*Please enter user name';
        }else if(values.nameRegister === ''){
        errors.nameRegister = '*Please enter user name';
        }      
        if (values.emailRegister && values.emailRegister.trim() === '') {
          errors.emailRegister = '*Please enter emailid';
        }else if(values.emailRegister === undefined){
            errors.emailRegister = '*Please enter emailid';
        }else if (!pattern.test(values.emailRegister)) {
            errors.emailRegister = "*Please enter valid email address.";
        }
    
        if(values.passwordRegister && values.passwordRegister.trim() === ''){
          errors.passwordRegister = '*Please enter password';
        }else if(values.passwordRegister === null){
          errors.passwordRegister = '*Please enter password';
        }else if(values.passwordRegister === undefined){
          errors.passwordRegister = '*Please enter password';
        }else if(values.passwordRegister === ''){
          errors.passwordRegister = '*Please enter password';
        }     
        return errors;      
    }

    registerSubmit = e =>{
        e.preventDefault();
        this.setState({
            isSubmited: true,        
        }, () => { });
        this.validate(this.state);
        const errors = this.validate(this.state);
        if (Object.keys(errors).length === 0) { 
            let requestData = {
                nameRegister : this.state.nameRegister,
                emailRegister : this.state.emailRegister,
                passwordRegister: this.state.passwordRegister
            }
            this.setState({
                isLoader: true
            })
            this.props.createRegister(requestData)
        }

    }

    loginvalidate(values) {
        const errors = {};      
        if (values.email && values.email.trim() === '') {
          errors.email = '*Please enter emailid';
        }else if(values.email === undefined){
            errors.email = '*Please enter emailid';
        }else if (!pattern.test(values.email)) {
            errors.email = "*Please enter valid email address.";
        }
    
        if(values.password && values.password.trim() === ''){
          errors.password = '*Please enter password';
        }else if(values.password === null){
          errors.password = '*Please enter password';
        }else if(values.password === undefined){
          errors.password = '*Please enter password';
        }else if(values.password === ''){
          errors.password = '*Please enter password';
        }     
        return errors;      
    }

    LoginHandelSubmit = e =>{
        e.preventDefault();
        this.setState({
            isLoginSubmited: true,        
        }, () => { });
        this.loginvalidate(this.state);
        const errors = this.loginvalidate(this.state);
        if (Object.keys(errors).length === 0) { 
            let requestData = {
                email:this.state.email,
                password:this.state.password,
            }
            this.setState({
                isLoader: true,
                loginRemove: true
            })
            this.props.login_list(requestData)
        }       
    }


    componentWillReceiveProps(nextProps){
        if(nextProps.doLoginRes && nextProps.doLoginRes.user){
            if(nextProps.doLoginRes.user && nextProps.doLoginRes.user.LoginRes){
                if(nextProps.doLoginRes.user.LoginRes && nextProps.doLoginRes.user.LoginRes.result === true && this.state.loginRemove === true){
                    localStorage.setItem('userId', nextProps.doLoginRes.user.LoginRes.user_id);
                    localStorage.setItem('userName', nextProps.doLoginRes.user.LoginRes.name);
                    this.setState({
                        isLoader: false,
                        loginModalPopup:this.state.loginModalPopup,
                        userName : nextProps.doLoginRes.user.LoginRes.name,
                        cartCheck:true,
                        loginRemove: false
                        
                    },()=>{
                        this.props.getValue(false)
                        if(this.state.cartCheck){
                            const cartData={
                                user_id : localStorage.getItem('userId')                                
                            }
                            this.props.cartListView(cartData)
                        }
                    })
                    
                } else{
                    this.props.getValue(false)
                    this.setState({
                        isLoader: false,
                        loginModalPopup:this.state.loginModalPopup,
                    })
                }
            }
        }

        if(nextProps.doRegisterRes && nextProps.doRegisterRes.user){
            if(nextProps.doRegisterRes.user && nextProps.doRegisterRes.user.RegisterRes){
                if(nextProps.doRegisterRes.user.RegisterRes && nextProps.doRegisterRes.user.RegisterRes.result === true){
                    this.setState({
                        isLoader: false,
                        loginModalPopup:this.state.loginModalPopup,
                    })
                    this.props.getValue(false)
                }else{
                    this.props.getValue(false)
                    this.setState({
                        isLoader: false,
                        loginModalPopup:this.state.loginModalPopup,
                    })
                }
            }
        }
    }

    render() {
        
        const errors = this.validate(this.state);
        const errorsLogin = this.loginvalidate(this.state)
        const { isSubmited, isLoginSubmited} = this.state;
        const spinner = <span><img src={loaderImg} alt="" /></span>;
        return (
            <React.Fragment>
                <Loader show={this.state.isLoader} message={spinner}>  
                    <div className="container login-container">                        
                        <div className="row pb-0">
                            <div className="col-md-6 login-form-1 bg-color-login">
                                <h3>LOGIN</h3>
                                <form onSubmit ={this.LoginHandelSubmit}>
                                    <div className="form-group">
                                        <input type="email" className="form-control" name="email"  onChange={(e) => this.setState({email: e.target.value})} value={this.state.email} placeholder="Email address *" autoComplete="off"/>
                                        {errorsLogin && isLoginSubmited && <span className="error-message">{errorsLogin.email}</span>}
                                    </div>
                                    <div className="form-group">
                                        <input type="password" className="form-control" name="password"  onChange={(e) => this.setState({password: e.target.value})} value={this.state.password} placeholder=" Password *" autoComplete="off" />
                                        {errorsLogin && isLoginSubmited && <span className="error-message">{errorsLogin.password}</span>}
                                    </div>
                                    <div className="form-group">
                                        <button type="submit" className="btnSubmit">Login</button>
                                    </div>
                                    <div className="form-group">
                                        <Link to="/forgot-password" className="ForgetPwd">Forget Password?</Link>
                                    </div>
                                </form>
                            </div>
                            <div className="col-md-6 login-form-2">
                                <h3>REGISTER</h3>
                                <form onSubmit={this.registerSubmit}> 

                                    <div className="form-group">
                                        <input type="text" className="form-control" name="nameRegister" onChange={(e) => this.setState({nameRegister: e.target.value})} value={this.state.nameRegister} placeholder="Name *" autoComplete="off"/>
                                        {errors && isSubmited && <span className="error-message">{errors.nameRegister}</span>}
                                    </div> 

                                    <div className="form-group">
                                        <input type="email" className="form-control" name="emailRegister" onChange={(e) => this.setState({emailRegister: e.target.value})} value={this.state.emailRegister} placeholder="Email Address *" autoComplete="off"/>
                                        {errors && isSubmited && <span className="error-message">{errors.emailRegister}</span>}
                                    </div>  
                                                
                                    <div className="form-group">
                                        <input type="password" className="form-control" name="passwordRegister" onChange={(e) => this.setState({passwordRegister: e.target.value})} value={this.state.passwordRegister} placeholder="Password *" autoComplete="off"/>
                                        {errors && isSubmited && <span className="error-message">{errors.passwordRegister}</span>}
                                    </div>
                                    <div className="form-group">
                                        <button type="submit" className="btnSubmit" >Register</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div> 
                </Loader> 
            </React.Fragment>
        )
    }
}

LoginRegister.propTypes = {
    doLoginRes: PropTypes.any,
    doRegisterRes: PropTypes.any,
    doCartListRes: PropTypes.any,  
};

const mapStateToProps = createStructuredSelector({
    doLoginRes:  doLoginRes,
    doRegisterRes: doRegisterRes,
    doCartListRes: doCartListRes,
});

function mapDispatchToProps(dispatch) {
   return {
       login_list: (data) => dispatch(login_list(data)),
       createRegister: (data) => dispatch(createRegister(data)),
       cartListView: (data) => dispatch(cartListView(data)),
       
   };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default  compose(withConnect)(LoginRegister)
